interface ErrorStateProps {
  message: string;
  onRetry: () => void;
  onClear: () => void;
}

export function ErrorState({ message, onRetry, onClear }: ErrorStateProps) {
  return (
    <div style={{
      marginTop: '16px',
      padding: '20px',
      background: 'var(--error-bg)',
      border: '1px solid var(--error-border)',
      borderRadius: '12px',
    }}>
      <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--error-text)', marginBottom: '4px', margin: 0 }}>
        Something went wrong
      </p>
      <p style={{ fontSize: '13px', color: 'var(--error-text)', opacity: 0.8, lineHeight: 1.5, margin: 0, marginTop: '4px' }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
        <button onClick={onRetry} style={{
          padding: '8px 16px', borderRadius: '8px', border: 'none',
          background: 'var(--accent)', color: 'var(--btn-primary-text)',
          fontSize: '13px', fontWeight: 600, cursor: 'pointer',
        }}>Try again</button>
        <button onClick={onClear} style={{
          padding: '8px 16px', borderRadius: '8px',
          border: '1px solid var(--border)',
          background: 'none', color: 'var(--text-muted)',
          fontSize: '13px', cursor: 'pointer',
        }}>Clear input</button>
      </div>
    </div>
  );
}
